var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scroll",staticClass:"wrap-item",on:{"scroll":_vm.scrollPage}},[_vm._t("default",null,null,_vm.items)],2)}
var staticRenderFns = []

export { render, staticRenderFns }